import React from 'react';
import ObservationChatWindow from '../../components/ObservationChatWindow';

const ChatApp = () => {
  return (
    <div className="chat-app">
      <ObservationChatWindow />
    </div>
  );
};

export default ChatApp; 